import React, {useState} from 'react'

const HoldTimeInput = ({value = {holdTime: 0, unitTime: 'hours'}, onChange = (e, v) => {}}) => {
  const [minutesSelected, setMinutesSelected] = useState(value.unitTime)

  const handleChangeText = e => {
    const v = parseInt(e.target.value)
    const _v = isNaN(v) ? 0 : Math.abs(v)
    if (_v <= 9999) {
      onChange(e, {...value, holdTime: _v})
    }
  }

  const handleChangeSelect = e => {
    onChange(e, {...value, unitTime: e.target.value, holdTime: 0})
    setMinutesSelected(e.target.value)
  }

  return (
    <div className={`ap-input-group`}>
      {minutesSelected === 'minutes' && (
        <select
          value={value.holdTime || '-'}
          onChange={handleChangeText}
          className={`ap-input-group__item`}
          style={{
            flex: '0 0 50px',
            width: '60px',
            padding: '5px',
          }}
        >
          <option value="0">-</option>
          <option value="30">30</option>
          <option value="60">60</option>
          <option value="90">90</option>
          <option value="120">120</option>
          <option value="150">150</option>
          <option value="180">180</option>
          <option value="210">210</option>
          <option value="240">240</option>
          <option value="270">270</option>
          <option value="300">300</option>
        </select>
      )}
      {minutesSelected !== 'minutes' && (
        <input
          value={value.holdTime || '-'}
          onChange={handleChangeText}
          className={`ap-input-group__item`}
          style={{
            flex: '0 0 50px',
            width: '50px',
            padding: '8px',
            textAlign: 'center',
          }}
        />
      )}
      <select
        value={value.unitTime || ''}
        onChange={handleChangeSelect}
        className={`ap-input-group__item`}
        style={{
          flex: '0 0 78px',
          width: '78px',
        }}
      >
        <option value="minutes">Minutes</option>
        <option value="hours">Hours</option>
        <option value="days">Days</option>
      </select>
    </div>
  )
}

export default HoldTimeInput
